import React from 'react';

const FundingMetricGrid = ({ metrics = [] }) => (
  <div className="mb-6 grid gap-4 sm:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-6" data-testid="funding-metric-grid">
    {metrics.map((metric) => (
      <div key={metric.id} className="fundgenius-hq-metric">
        <div className="text-xs font-medium uppercase tracking-[0.12em] text-[var(--fg-muted)]">
          {metric.label}
        </div>
        <div className="mt-2 text-2xl font-bold text-[var(--fg-text)]">{metric.value}</div>
        {metric.delta ? (
          <div className="mt-1 text-xs text-[var(--fg-muted)]">{metric.delta}</div>
        ) : null}
      </div>
    ))}
  </div>
);

export default FundingMetricGrid;
